/* Zabdi: precios cerca del nombre y títulos alineados por fila. */
(() => {
  const titleSelector = [
    '.card > .card__content > .card__information > .card__heading',
    '.zabdi-rec-card__details > h3',
    '.zabdi-coco-tile__title', '.zabdi-kefir-tile__title',
    '.zabdi-ghee-tile__title', '.zabdi-packs-tile__title',
    '.zabdi-despensa-tile__title', '.zabdi-granola-tile__title'
  ].join(',');
  const cardSelector = '.card-wrapper,.zabdi-rec-card,.zabdi-coco-tile,.zabdi-kefir-tile,.zabdi-ghee-tile,.zabdi-packs-tile,.zabdi-despensa-tile,.zabdi-granola-tile';
  const priceSelector = '.card-information .price,.zabdi-rec-card__price,.zabdi-coco-tile__price,.zabdi-kefir-tile__price,.zabdi-ghee-tile__price,.zabdi-packs-tile__prices,.zabdi-despensa-tile__price,.zabdi-granola-tile__price';
  const set = (el, values) => {
    if (!el) return;
    for (const [key, value] of Object.entries(values)) el.style.setProperty(key, value, 'important');
  };
  let pending;
  function compact() {
    pending = null;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const entries = [];
    main.querySelectorAll(titleSelector).forEach(title => {
      const card = title.closest(cardSelector);
      if (!card || !title.getClientRects().length) return;
      const price = card.querySelector(priceSelector);
      if (!price) return;
      set(title, {'min-height':'0', 'margin-bottom':'0', 'padding-bottom':'0', 'align-items':'flex-start'});
      const details = title.parentElement;
      set(details, {'min-height':'0', 'flex':'0 0 auto', 'justify-content':'flex-start'});
      if (!title.matches('.card__heading')) {
        set(details, {'display':'flex','flex-direction':'column','gap':'0'});
      }
      const information = card.querySelector('.card-information');
      set(information, {'min-height':'0','margin-top':'0','flex':'0 0 auto','justify-content':'flex-start'});
      set(price, {'margin-top':'8px','padding-top':'0','min-height':'0','align-items':'center','justify-content':'center','flex':'0 0 auto','align-self':'center','text-align':'center','width':'100%','margin-left':'0','margin-right':'0'});
      if (price.matches('.zabdi-packs-tile__prices')) set(price, {'justify-content':'flex-start'});
      if (price.matches('.zabdi-despensa-tile__price')) set(price.querySelector('.price'), {'margin-top':'0'});
      const section = card.closest('.shopify-section') || main;
      entries.push({title, price, card, section, top:card.getBoundingClientRect().top, height:title.getBoundingClientRect().height});
    });
    const rows = [];
    for (const entry of entries) {
      let row = rows.find(row => row.section === entry.section && Math.abs(row.top - entry.top) < 4);
      if (!row) { row = {section:entry.section,top:entry.top,height:0,entries:[]}; rows.push(row); }
      row.entries.push(entry);
      row.height = Math.max(row.height, entry.height);
    }
    for (const row of rows) {
      for (const entry of row.entries) set(entry.title, {'min-height':Math.ceil(row.height)+'px'});
      // Reserva únicamente el espacio del precio anterior cuando la fila tiene ofertas.
      const prices = row.entries.map(entry => {
        const anchor = entry.price.querySelector('.zabdi-packs-tile__price') || entry.price;
        return {entry, bottom:anchor.getBoundingClientRect().bottom};
      });
      const baseline = Math.max(...prices.map(item => item.bottom));
      for (const {entry, bottom} of prices) {
        set(entry.price, {'margin-top':(8 + Math.max(0, baseline - bottom))+'px'});
      }
    }
  }
  function schedule() {
    if (pending) cancelAnimationFrame(pending);
    pending = requestAnimationFrame(compact);
  }
  function init() {
    schedule();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(schedule).observe(main, {childList:true,subtree:true});
    if (document.fonts) document.fonts.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
